import { render, staticRenderFns } from "./StatisticsGeneralComparision.vue?vue&type=template&id=3138bed7"
import script from "./StatisticsGeneralComparision.vue?vue&type=script&lang=js"
export * from "./StatisticsGeneralComparision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports